/**
 * This module will disable Brave's crypto wallet messages
 *
 * See https://github.com/brave/brave-core/blob/master/components/brave_extension/extension/brave_extension/content_dapps.ts
 *
 * <i>Copyright (c) 2020 Energi Cryptocurrency - https://energi.world</i><br>
 * Proprietary License
 *
 *
 * @module suppress-brave-cryptowallet.js
 * @class SuppressBraveCryptowallet
 * @since 0.4.12
*/

const later = require('itsa-utils').later;

const suppressMsg = () => {
    const timer = later(() => {
        let braveDappDetectionNode = document.head.querySelector('meta[name="dapp-detected"]');

        if (braveDappDetectionNode) {
            braveDappDetectionNode.parentNode.removeChild(braveDappDetectionNode);
            timer.cancel();
        }
    }, 0, 250); // delay 0ms (still async), and repeat every 250ms

    // make sure to stop the timer when no dom node got inserted:
    later(() => {
        timer.cancel();
    }, 5000);
};


module.exports = {
    suppressMsg
};
